import request from '@/utils/request'

// 获取过磅列表
export function getHistoryList(data) {
  const { material, ...params } = data
  return request.get('/inventoryRecord/queryAll', {
    params: {
      ...params,
      materialName: material
    }
  })
}

